import React, { useState, useEffect, useRef } from 'react';
import { HelpCircle, MessageSquare, ExternalLink, Sparkles } from 'lucide-react';
import packageJson from '../../package.json';
import QRCode from 'qrcode';

const Footer = ({ onShowHelp }) => {
  const [showFeedbackTooltip, setShowFeedbackTooltip] = useState(false);
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState('');
  const laWidgetRef = useRef(null);

  useEffect(() => {
    // 生成QQ群二维码
    const qqGroupUrl = 'https://qm.qq.com/q/qgHLoJ6vke';
    QRCode.toDataURL(qqGroupUrl, {
      width: 200,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      }
    }).then(url => {
      setQrCodeDataUrl(url);
    }).catch(err => {
      console.error('生成二维码失败:', err);
    });

    // 加载51.la统计脚本
    if (laWidgetRef.current && !document.getElementById('LA-DATA-WIDGET')) {
      const script = document.createElement('script');
      script.id = 'LA-DATA-WIDGET';
      script.crossOrigin = 'anonymous';
      script.charset = 'UTF-8';
      script.src = 'https://v6-widget.51.la/v6/3NQ4sGiyrhidvRH8/quote.js?theme=0&f=12&display=0,1,0,0,0,0,0,1';
      script.async = true;
      laWidgetRef.current.appendChild(script);
    }
  }, []);

  return (
    <div className="bg-black/20 backdrop-blur-md text-white py-5 mt-10 border-t border-white/20">
      <div className="max-w-6xl mx-auto px-5">
        <div className="flex justify-between items-center mb-4 flex-wrap gap-4">
          <div className="flex items-center gap-4 flex-wrap">
            <span className="bg-primary-600 text-white px-3 py-1 rounded-full text-xs font-semibold">v{packageJson.version}</span>
            <span className="text-sm text-gray-400">2025年9月更新</span>
            {/* AiQiji工具箱链接 */}
            <div className="inline-flex items-center gap-2 group">
              <span className="text-gray-600 text-sm">|</span>
              <Sparkles className="w-4 h-4 text-yellow-400 group-hover:animate-pulse" />
              <span className="text-sm text-gray-400">本工具收录至：</span>
              <a
                href="https://tools.aiqji.com"
                target="_blank"
                rel="noopener"
                title="AiQiji工具箱 - 专业的AI工具集合平台"
                className="inline-flex items-center gap-1 text-blue-400 hover:text-blue-300 transition-all duration-300 group-hover:scale-105 font-medium"
              >
                <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent font-bold">
                  AiQiji·工具箱
                </span>
                <ExternalLink className="w-3 h-3 opacity-70 group-hover:opacity-100 transition-opacity" />
              </a>
              <Sparkles className="w-4 h-4 text-yellow-400 group-hover:animate-pulse" />
            </div>
          </div>
          <div className="flex items-center gap-4 flex-wrap">
            {/* 51.la 统计组件 */}
            <div 
              ref={laWidgetRef}
              className="flex items-center text-sm text-gray-400"
              style={{ minHeight: '20px' }}
            ></div>
            <button 
              onClick={onShowHelp}
              className="flex items-center gap-2 text-gray-400 text-sm hover:text-white transition-colors duration-300"
            >
              <HelpCircle size={16} />
              使用帮助
            </button>
            <span className="text-gray-600 text-sm">|</span>
            <div className="relative">
              <button 
                onMouseEnter={() => setShowFeedbackTooltip(true)}
                onMouseLeave={() => setShowFeedbackTooltip(false)}
                className="flex items-center gap-2 text-gray-400 text-sm hover:text-white transition-colors duration-300"
              >
                <MessageSquare size={16} />
                意见反馈
              </button>
              
              {/* 意见反馈弹窗 */}
              {showFeedbackTooltip && (
                <div className="absolute bottom-full right-0 mb-2 bg-white rounded-lg shadow-lg p-4 border border-gray-200 z-50 min-w-64">
                  <div className="text-center">
                    <p className="text-gray-800 text-sm font-medium mb-3">扫码添加开发者QQ反馈</p>
                    <div className="bg-white p-4 rounded-lg border border-gray-200">
                      {qrCodeDataUrl ? (
                        <img 
                          src={qrCodeDataUrl} 
                          alt="QQ群二维码" 
                          className="w-52 h-52 mx-auto"
                          style={{ width: '208px', height: '208px' }}
                        />
                      ) : (
                        <div className="w-52 h-52 bg-gray-100 rounded flex items-center justify-center" style={{ width: '208px', height: '208px' }}>
                          <span className="text-gray-400 text-sm">加载中...</span>
                        </div>
                      )}
                    </div>
                    <p className="text-gray-500 text-xs mt-1">请使用QQ扫描二维码添加开发者QQ反馈</p>
                  </div>
                  {/* 小三角箭头 */}
                  <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-white"></div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="text-center pt-4 border-t border-gray-700">
          <p className="text-sm text-gray-400">&copy; 2024 - 2025 AiQiji-吉庆喆. 保留所有权利.</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
